import { format } from "date-fns";
import { motion } from "framer-motion";
import React from "react";
import { useContext, useEffect } from "react";
import { EaseContext, WidthContext } from "../App";
import { getPredictData } from "../libs/firebase";
import { State } from "./KlimaContent";

interface Props {
  setCurrentState: (state: State) => void;
  setIsFirst: (isFirst: boolean) => void;
  isFirst: boolean;
}

export const WelcomeContent: React.FC<Props> = ({
  setCurrentState,
  setIsFirst,
  isFirst,
}) => {
  const [predictData, setPredictData] = React.useState("-");
  useEffect(() => {
    (async () => {
      const _predictData = await getPredictData()
      setPredictData(`${_predictData !== -1 ? _predictData : "-"}`);
    })();
  }, []);

  const handleClick = () => {
    setCurrentState("question");
    setIsFirst(false);
    window.scrollTo(0, 0);
  };

  const width = useContext(WidthContext);
  const ease = useContext(EaseContext);

  const now = new Date();
  const dayText = format(now, "MM月dd日");

  return (
    <motion.div
      initial={isFirst ? { opacity: 0, x: 0 } : { opacity: 1, x: width }} // 初期状態
      animate={{ opacity: 1, x: 0 }} // マウント時
      exit={{ x: 20 }} // アンマウント時
      transition={{
        duration: 0.5,
        ease: ease,
      }}
    >
      <div className="w-full rounded-xl shadow-lg mt-8 mb-4 md:px-6 py-10 bg-slate-50 px-2" >
        <h1 className="text-center text-2xl md:text-3xl mb-2 font-semibold text-gray-10 leading-8">
          カーボンフットプリント<br />ばりぐっどくん
        </h1>
        <div className="flex justify-center">
          <img src="/images/welcome.png" alt="welcome" className="h-64" />
        </div>
        <p className="px-2 md:px-6 py-3 text-sm leading-[1.6] text-gray-10">
          <span className="block md:inline text-center">
            簡単なアンケートに答えるだけで、
          </span>
          <span className="block md:inline text-center">
            あなたの年間CO2排出量を計算できるよ！
          </span>
        </p>
        <div className="flex justify-center mt-5 mb-3 px-4">
          <button className="btn w-full text-slate-50" onClick={handleClick}>
            はじめる
          </button>
        </div>
      </div>

      <div className="w-full rounded-xl shadow-lg mt-4 mb-8 md:px-6 pt-4 pb-4 bg-orange-100 px-4 flex flex-col">
        <div className="flex flex-col items-center">
          <div className="">{dayText}の西海市施設の電力使用量予報</div>
          <div className="text-4xl font-bold mt-1 mb-3">
            {predictData}<span className="ml-1 text-2xl">kWh</span>
          </div>
        </div>

        <div className="flex items-end">
          <div className="flex-1">
            developed by <a href="https://vgu.community/" target="_blank" rel="noreferrer" className="underline">VGU</a>
          </div>
          <div>
            <a href="https://saikai-co2.varygoodkun.net/" target="_blank" className="px-2 py-2 rounded-lg bg-slate-900 text-white text-xs " rel="noreferrer">電力見える化について知る</a>
          </div>
        </div>
      </div>
    </motion.div >
  );
};
